module.exports = __webpack_public_path__ + "static/media/header-regulamin.a65f1070.svg";